require('./bootstrap');

import Vue from 'vue';
import FlickityCarousel from './components/FlickityCarousel.vue';
import MainMenu from './enso/MainMenu.js';
import MapComponent from './components/MapComponent.vue';
import PostsIndex from './components/PostsIndex.vue';
import PostPreview from './components/PostPreview.vue';
import SvgSprite from './vendor/enso/components/SvgSprite.vue';

new Vue({
  el: '#app',
  components: {
    FlickityCarousel,
    MainMenu,
    MapComponent,
    PostsIndex,
    PostPreview,
    SvgSprite,
  },
});

const cookieNotification = document.getElementById('cookieNotification');
const cookieDismiss = document.getElementById('cookieNotificationDismiss');

function checkCookies() {
  if (!localStorage.getItem('keynote_cookie_notification_shown')) {
    cookieNotification.style.display = '';
  }
}

window.addEventListener('load', () => {
  checkCookies();
});

cookieDismiss.addEventListener('click', (e) => {
  e.preventDefault();
  localStorage.setItem('keynote_cookie_notification_shown', true);
  cookieNotification.style.display = 'none';
});
